import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSION_ITEM } from '../../../../../../../webcomponents.constants';
import { descriptionValidators, ipValidators } from '../utils/validators';

@customElement(WEB_COMPONENT_POLICY_PANEL_FIREWALL_SETTINGS_EXCLUSION_ITEM)
export class GzFirewallSettingsExclusionItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#exclusionItemIp')
  exclusionItemIp: GzFormFieldWebComponent<GzInputWebComponent, string>;

  @query('#exclusionItemDescription')
  exclusionItemDescription: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.exclusionItemIp.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field input--w25">
        <gz-form-field id="exclusionItemIp">
          <gz-input
            gz-form-input
            label="${translateFn('IP/mask')}"
            placeholder="${translateFn('Enter IP/mask')}"
          ></gz-input>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field input--w25">
        <gz-form-field id="exclusionItemDescription">
          <gz-input
            gz-form-input
            label="${translateFn('Description')}"
            placeholder="${translateFn('Enter a description')}"
          ></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  focusFirstInput(): void {
    this.exclusionItemIp.Input.inputFocus();
  }

  createFormGroup(): void {
    this.exclusionItemIp.Validators = ipValidators();
    this.exclusionItemDescription.Validators = descriptionValidators();

    this.formGroup = new FormGroup({
      ip: this.exclusionItemIp,
      description: this.exclusionItemDescription,
    });
  }

  resetForm(): void {
    this.exclusionItemIp.value = '';
    this.exclusionItemIp.resetField();

    this.exclusionItemDescription.value = '';
    this.exclusionItemDescription.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm();
  }
}
